const consentCheckbox = document.querySelector(".js-quest-briefing-consent");
const startButton = document.querySelector(".js-quest-start-btn");

if (consentCheckbox && startButton) {
  // Initially disable the start button
  startButton.classList.add("btn--disabled");
  startButton.style.pointerEvents = "none";
  startButton.style.opacity = "0.5";

  // Enable/disable button based on checkbox state
  consentCheckbox.addEventListener("change", () => {
    if (consentCheckbox.checked) {
      startButton.classList.remove("btn--disabled");
      startButton.style.pointerEvents = "auto";
      startButton.style.opacity = "1";
    } else {
      startButton.classList.add("btn--disabled");
      startButton.style.pointerEvents = "none";
      startButton.style.opacity = "0.5";
    }
  });
}
